<template>
    <div class="modal modal-open" id="modal-add-service">
        <div class="modal-overflow">
            <div class="modal-window">
                <button
                    class="btn btn-modal-close"
                    type="button"
                    @click="handleClose"
                >
                    <i class="icon icon-cancel"></i>
                </button>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-xl-12 col-lg-12">
                            <div class="form-field form-field--tree">
                                <label for="name"
                                    >Service
                                    <span style="color: #ec4657">*</span>
                                    <span
                                        style="
                                            color: #ec4657;
                                            font-size: 12px;
                                            cursor: pointer;
                                            font-weight: 600;
                                        "
                                        @click="toggleNewServiceModal"
                                        >Add new</span
                                    ></label
                                >
                                <treeselect
                                    v-model="new_data.service_id"
                                    :multiple="false"
                                    :options="options"
                                    @select="onChangeServiceSelect"
                                    :clearOnSelect="true"
                                />
                                <span
                                    style="left: 0"
                                    class="error"
                                    v-if="errors.service_id"
                                    >{{ errors.service_id }}</span
                                >
                            </div>
                        </div>
                        <div class="col-xl-12 col-lg-12">
                            <div class="form-field form-field--text">
                                <label for="name"
                                    >Agency service
                                    <span style="color: red">*</span></label
                                >
                                <input
                                    type="text"
                                    v-model="new_data.name"
                                    id="agency_service"
                                />
                                <span
                                    style="left: 0"
                                    class="error"
                                    v-if="errors.name"
                                    >{{ errors.name }}</span
                                >
                            </div>
                        </div>
                        <div class="col-xl-12 col-lg-12">
                            <div class="form-field form-field--text">
                                <label for="name">Min budget, $</label>
                                <CurrencyInput
                                    :id="'min_budget'"
                                    :name="'min_budget'"
                                    v-model="new_data.min_budget"
                                    :options="{
                                        currency: 'USD',
                                        hideCurrencySymbolOnFocus: false,
                                        hideGroupingSeparatorOnFocus: false,
                                        hideNegligibleDecimalDigitsOnFocus: false,
                                    }"
                                />
                                <span
                                    style="left: 0"
                                    class="error"
                                    v-if="errors.min_budget"
                                    >{{ errors.min_budget }}</span
                                >
                            </div>
                        </div>
                        <div class="col-xl-12 col-lg-12">
                            <div class="form-field form-field--text">
                                <label for="name">Case study url</label>
                                <input
                                    type="text"
                                    v-model="new_data.cases_url"
                                    id="cases_url"
                                />
                            </div>
                        </div>
                        <div class="col-xl-12 col-lg-12">
                            <div class="btn-wrap jus-c--center">
                                <button
                                    @click="handleAdd"
                                    type="button"
                                    class="btn"
                                >
                                    Add
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <AddNewServiceModal
            v-if="isOpenNewServiceModal"
            :serviceOptions="options"
            :onAdd="createNewService"
            :onClose="toggleNewServiceModal"
        />
    </div>
</template>

<script>
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import CurrencyInput from "../CurrencyInput";
import AddNewServiceModal from "./modals/AddNewService.vue";

export default {
    name: "addService",
    props: {
        onClose: {
            type: Function,
            required: true,
        },
        onAdd: {
            type: Function,
            required: true,
        },

        isEdit: {
            type: Number,
            required: false,
        },
        editData: {
            type: Object,
            required: false,
        },
        onEdit: {
            type: Function,
            required: false,
        },
    },
    components: {
        Treeselect,
        AddNewServiceModal,
        CurrencyInput,
    },
    data() {
        return {
            // define the default value
            // define options
            options: [],

            new_data: {
                name: "",
                cases_url: "",
                min_budget: 0,
                service_id: null,
            },

            errors: {
                name: null,
                service_id: null,
                min_budget: null,
            },

            isOpenNewServiceModal: false,
        };
    },

    async mounted() {
        console.log(this.editData);
        this.getServices();
    },

    methods: {
        getServices() {
            axios
                .get("/agencies/business/getServices")
                .then((r) => {
                    this.options = r.data;
                })
                .finally((r) => {
                    if (this.isEdit) {
                        this.new_data = JSON.parse(
                            JSON.stringify(this.editData)
                        );
                        this.$forceUpdate();
                    }
                });
        },
        handleClose(e) {
            this.onClose(e);
        },
        handleAdd(e) {
            this.validationFields();

            if (
                this.errors.name ||
                this.errors.service_id ||
                this.errors.min_budget
            ) {
                return;
            }

            if (this.isEdit) {
                this.onEdit(this.isEdit, this.new_data);
                return;
            }

            this.onAdd({
                name: this.new_data.name,
                cases_url: this.new_data.cases_url,
                min_budget: this.new_data.min_budget,
                service_id: this.new_data.service_id,
            });
        },
        validationFields() {
            this.errors.name = null;
            this.errors.service_id = null;
            this.errors.min_budget = null;

            if (!this.new_data.name) {
                this.errors.name = "Required";
            }

            if (!this.new_data.service_id) {
                this.errors.service_id = "Required";
            }

            if (
                this.new_data.min_budget &&
                (this.new_data.min_budget < 0 ||
                    !/^\d+$/.test(this.new_data.min_budget))
            ) {
                this.errors.min_budget = "Invalid value. Only numbers";
            }
        },

        createNewService(params) {
            axios
                .post("/service/create", params)
                .then((res) => {
                    if (res.data) {
                        this.new_data.service_id = res.data.service.id;
                        this.new_data.name = res.data.service.label;
                        this.getServices();
                        this.isOpenNewServiceModal = false;
                    }
                })
                .catch((err) => {
                    console.error(err);
                });
        },

        onChangeServiceSelect({ id, label }) {
            this.new_data.name = label;
        },

        toggleNewServiceModal() {
            this.isOpenNewServiceModal = !this.isOpenNewServiceModal;
        },
    },
};
</script>
